import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

// API URL configuration
// For production builds, REACT_APP_API_URL MUST be set
// Using empty string for dev lets the proxy handle requests
const API_URL = isDev
  ? ""
  : (process.env.REACT_APP_API_URL || "");  // Fail loudly if not set in production

if (!isDev && !process.env.REACT_APP_API_URL) {
  console.error(
    "[CONFIG ERROR] REACT_APP_API_URL environment variable is not set! " +
    "Set it in your .env file or CI/CD pipeline."
  );
  // In production, this will cause API calls to fail immediately
  // making misconfiguration obvious rather than silently hitting wrong server
}

console.log(
  isDev
    ? "🔗 API: dev (proxied via package.json)"
    : `🔗 API: ${API_URL || '[NOT CONFIGURED - WILL FAIL]'}`
);

const api = axios.create({
  baseURL: API_URL,
});

export default api;
